// extracted by mini-css-extract-plugin
export default {"bar":"fileActionBar_bar__UgB1C","left":"fileActionBar_left__ys3ic","right":"fileActionBar_right__PZZI0"};